import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import StdPerfRow from './StdPerfRow'
import './PerformanceTable.css'
import i18n from '../../../i18n'

class StdPerfTable extends Component {
  // create the rows
  renderRows() {
    const { data, wtRegion } = this.props

    return data
      .filter(x => !['BMK', 'WTIDX'].includes(x.type))
      .map(fund => {
        return <StdPerfRow key={fund.externalID} fund={fund} wtRegion={wtRegion} />
      })
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }
  // create the header
  renderHeader() {
    const { wtRegion } = this.props

    const asOfDate = this.props.data[0].stdPerformance && this.props.data[0].stdPerformance[0].asOfDate ? new Date(this.props.data[0].stdPerformance[0].asOfDate).toLocaleDateString() : new Date().toLocaleDateString()
    const commonStartDate = new Date(this.props.data[0].stdPerformance[0].commonPeriodNAVStart).toLocaleDateString()
    const commonEndDate = new Date(this.props.data[0].stdPerformance[0].commonPeriodNAVEnd).toLocaleDateString()
    return (
      <thead>
        <tr>
          <th colSpan='3' className='textLeft'>
            STANDARDIZED PERFORMANCE
            <br />
            {i18n.t('as of')} {asOfDate}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th colSpan='3' className='borderleft borderbottom textCenter'>
                {i18n.t('Cumulative Returns')}
              </th>
            </Fragment>
          )}
          <th colSpan='6' className='borderleft borderbottom textCenter'>
            {i18n.t('Average Annual Total Returns')}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>
            {i18n.t('Ticker')}
          </th>
          <th scope='col' className='textLeft'>
            {i18n.t('Fund')}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th scope='col' className='textCenter'>
                {i18n.t('Inception')}
                <br /> {i18n.t('Date')}
              </th>
              <th scope='col' className='borderleft textCenter'>
                {i18n.t('1-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('3-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('YTD')}
              </th>
            </Fragment>
          )}
          <th scope='col' className='borderleft textCenter'>
            {i18n.t('1-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('3-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('5-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('10-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Since')} <br />
            {i18n.t('Inception')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Common Period')}
            <br /> {commonStartDate} - {commonEndDate}{' '}
          </th>
        </tr>
      </thead>
    )
  }

  render() {
    const { data } = this.props

    // check if data and stdPerformance exist and are not null
    if (!data || !data[0] || !data[0].stdPerformance) {
      return null // or return a loading indicator, or some placeholder content
    }
    return (
      <div>
        {/* <div className={s.heading} style={{lineHeight:'14px', marginBottom:'13px'}}>{i18n.t('Standardized Performance')}</div> */}
        <div className='table-responsive'>
          <table className='table tableFC'>
            {this.renderHeader()}
            <tbody>{this.renderRows()}</tbody>
          </table>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    wtRegion: state.params.wtRegion
  }
}

export default connect(mapStateToProps, {})(StdPerfTable)
